import React from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function KeyboardShortcutsDialog({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  const keySx = {
    display: 'inline-block',
    p: '2px 6px',
    fontSize: '12.5px',
    fontFamily: 'monospace',
    bgcolor: 'rgba(255,255,255,0.1)',
    border: '1px solid rgba(255,255,255,0.2)',
    borderRadius: 1,
    minWidth: 24,
    textAlign: 'center' as const,
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          bgcolor: 'background.paper',
          backdropFilter: 'blur(8px)',
          borderRadius: '6px',
          border: '1px solid',
          borderColor: 'divider',
        },
      }}
      slotProps={{ backdrop: { sx: { bgcolor: 'rgba(0,0,0,0.6)' } } }}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pr: 1, borderBottom: '1px solid', borderColor: 'divider' }}>
        <Typography variant="h6" fontWeight={600}>Keyboard Shortcuts</Typography>
        <IconButton aria-label="Close" size="small" onClick={onClose} sx={{ color: 'text.secondary' }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ py: 2 }}>
        <Box sx={{ display: 'grid', gap: 2 }}>
          <Box>
            <Typography variant="subtitle2" color="primary.main" fontWeight={600} sx={{ mb: 1 }}>Navigation</Typography>
            <Box sx={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: 1, alignItems: 'center', rowGap: 0.75 }}>
              <Box component="kbd" sx={keySx}>Ctrl+K</Box>
              <Typography variant="body2">Command palette</Typography>
              <Box component="kbd" sx={keySx}>Ctrl+/</Box>
              <Typography variant="body2">Show shortcuts</Typography>
            </Box>
          </Box>
          <Box>
            <Typography variant="subtitle2" color="primary.main" fontWeight={600} sx={{ mb: 1 }}>Inbox</Typography>
            <Box sx={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: 1, alignItems: 'center', rowGap: 0.75 }}>
              <Typography variant="caption" color="text.secondary" fontStyle="italic">(future)</Typography>
              <Typography variant="body2" color="text.secondary">Next thread</Typography>
              <Typography variant="caption" color="text.secondary" fontStyle="italic">(future)</Typography>
              <Typography variant="body2" color="text.secondary">Previous thread</Typography>
            </Box>
          </Box>
          <Box>
            <Typography variant="subtitle2" color="primary.main" fontWeight={600} sx={{ mb: 1 }}>Time Tracking</Typography>
            <Box sx={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: 1, alignItems: 'center', rowGap: 0.75 }}>
              <Box component="kbd" sx={keySx}>Alt+T</Box>
              <Typography variant="body2">Open quick timer / stop timer</Typography>
            </Box>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
